import React from "react";
import contactUs from "../../PicesForPages/ContactUs.webp";
import ContactForm from "../Form/ContactForm";

function ContactUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={contactUs}
          alt="contactUsImage"
          className="background-video aboutUsImage rightLoanForYouImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>Contact Us</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox contactUsBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Get In Touch</span>
            <a
              href="tel:+1-610-618-0618"
              style={{ textDecoration: "none" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Phone: </span>
              <span>(610) 618-0618</span>
            </a>
            <a
              href="mailto: Contact@TheMortgageist.com"
              style={{ textDecoration: "none" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Email: </span>
              <span>Contact@TheMortgageist.com</span>
            </a>
            <a
              href="https://maps.app.goo.gl/XvtFdfxwot8PEfuo6"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none", textAlign: "end" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Address: </span>
              <span className="contactUsAddress">
                150 Allendale Rd., Suite 2200, <br></br>King of
                Prussia, PA 19406
              </span>
            </a>
          </div>
          <ContactForm />
        </div>
      </div>
      <div className="addressBoxParent">
        <div className="addressBox">
          <div className="addressHeading">
            The address of{" "}
            <span className="logoBoldColor">The Mortgageist</span>
          </div>
          <div className="addressMapDetails">
            <iframe
              title="The Mortgageist Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3052.3351886554033!2d-75.3815754!3d40.0902391!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c695c98235120b%3A0xd79eff078b4cdb24!2s150%20Allendale%20Rd%20Unit%202200%2C%20King%20of%20Prussia%2C%20PA%2019406%2C%20USA!5e0!3m2!1sen!2sin!4v1746712641605!5m2!1sen!2sin"
              width="600"
              height="450"
              style={{ border: 0 }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <span className="addressDetails">
              <span className="addressDetailsTop">
                <span className="addressDetailsTopHeading">Contact Us:</span>
                <span>Email:Contact@TheMortgageist.com</span>
                <span>Phone: (610) 618-0618</span>
                <span>
                  Address: 150 Allendale Rd., Suite 2200, <br />
                  King of Prussia, PA
                  <br />
                  19406
                </span>
              </span>
              <span className="addressDetailsBottom">
                <span className="addressDetailsBottomHeading">
                  Office Hours:
                </span>
                <span>Monday-Friday: 9am to 6pm</span>
                <span>Saturday: 10am to 2pm</span>
                <span>Sunday: Closed</span>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
